import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Menu,
  Breadcrumb,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Divider,
  Tabs,
  Switch,
  Dropdown,
  Spin
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  MoreOutlined,
  EditOutlined,
  SyncOutlined
} from "@ant-design/icons";
import Container from "../Layout/Container";
import { Link, useHistory, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { getAllSubAdmin, subAdminuserSelector, clearState, subAdminStatusChange, SearchSubAdmin } from './subadminSlice';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;




const ntop = "none";
const nbottom = "bottomCenter";
export default function SubAdmin() {


  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);

  const [subadminUsername, setsubadminUsername] = React.useState("");

  const { isFetching, isSuccess, isError, errorMessage, subAdminuser, subAdminCount } = useSelector(
    subAdminuserSelector
  );

  const [subAdminData, setDataSource] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');




  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    return obj;
  };

  const onChange = (checked, sendData) => {
    // console.log(`switch to ${checked} ==> ${sendData.name} `);
    const data = { "username": sendData.user_name };
    if (search) {
      let q = search + '?page=' + page;
      dispatch(subAdminStatusChange(data));
      setTimeout(() => {
        dispatch(SearchSubAdmin(q)).then(res => {
          if (res) {
            let udata = res.data;
            setDataSource(udata);
            setPage(page);
          }
        });
      }, 100);

    } else {
      //  dispatch(getAllSubAdmin(page));
      dispatch(subAdminStatusChange(data));
      setTimeout(() => { dispatch(getAllSubAdmin(page)); }, 100);
    }
  };

  const ChangeSubAdminpagination = (v) => {

    if (search) {
      let q = search + '?page=' + v.current;
      dispatch(SearchSubAdmin(q)).then(res => {
        if (res) {
          let udata = res.data;
          setDataSource(udata);
          setPage(v.current);
        }
      });
    }
    else {
      let q = v.current;
      setPage(v.current);
      dispatch(getAllSubAdmin(q));
    }
  }



  const handleMenuClick = (e, row) => {
    //console.log("click", row);
    if (e.key == 1) {
      history.push({
        pathname: '/edit-sub-admin',
        state: { subAdminName: row.user_name }
      });

    }
  }

  const menu = (row) => (
    <Menu onClick={(e) => handleMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  const handleViewSubadminClick = (e, row) => {
    e.preventDefault();
    history.push({
      pathname: '/view-sub-admin',
      state: { subAdminName: row.user_name }
    });
  }

  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      render: (text, row, index) => {
        return {
          children: <a onClick={(e) => handleViewSubadminClick(e, row)} style={{ marginBottom: 0 }}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      render: renderContent,
    },
    {
      title: "Contact No.",
      dataIndex: "contact_no",
      render: renderContent,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, row, index) => {
        return {
          children: <Switch
            checked={text === "true" ? true : false}
            onChange={(e) => onChange(e, row)}
          />
          //  children: row.status=="true"?<Switch defaultChecked onChange={(v) =>onChange(v,row)} />:<Switch   onChange={(v) =>onChange(v,row)} />,

        };
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      render: (text, row, index) => (
        <Dropdown
          overlay={() => menu(row)}
          trigger={["click"]}
          placement="bottomRight"
          arrow
        >
          <a
            style={{ color: "#c5c7cd", fontSize: 25 }}
            onClick={(e) => e.preventDefault()}
          >
            <MoreOutlined />
          </a>
        </Dropdown>
      ),
      //render: () => <a style={{color:'#c5c7cd',fontSize:25}}><MoreOutlined /></a>,
    },
  ];



  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllSubAdmin(page));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(subAdminuser);
    }
  }, [isError, isSuccess, setLoading, subAdminuser, setDataSource]);



  let dataSource = isLoading
    ? []
    : subAdminData && subAdminData.allUsers ? subAdminData.allUsers.map(row => ({
      user_name: row.username,
      full_name: row.fullName,
      contact_no: row.phone,
      status: row && row.active && row.active[0]
    })) : [];

  dataSource = dataSource ? dataSource.slice().sort((a, b) => a.full_name.toLowerCase().localeCompare(b.full_name.toLowerCase())) : [];



  return (
    <>
      <Container>
        <div
          className="site-layout-content"
          style={{ marginTop: 30, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
            <h2
              style={{
                paddingLeft: 16,
                paddingTop: 20,
                borderTop: "1px solid #dfe0eb",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                marginBottom: 0,
                backgroundColor: "#ffffff"
              }}
            >
              Sub Admin ({subAdminData && subAdminData.count ? subAdminData.count : 0})
            </h2>
            <Space
              style={{
                padding: 16,
                width: "100%",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                backgroundColor: "#ffffff"
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="10">
                  {/* <Search placeholder="Search process"  size="large"  /> */}
                  <Input
                    placeholder="Search full name"
                    size="large"
                    suffix={<SearchOutlined />}
                    onChange={e => {
                      const currValue = e.target.value;
                      setSearch(currValue);
                      let q = currValue + '?page=1';
                      // console.log(q)
                      if (currValue) {
                        dispatch(SearchSubAdmin(q)).then(res => {
                          if (res) {
                            let udata = res.data;
                            setDataSource(udata);
                            //setPage(1);
                          }
                        });
                      }
                      else {
                        dispatch(SearchSubAdmin(q)).then(res => {
                          if (res) {
                            let udata = res.data;
                            setDataSource(udata);
                            setPage(1);
                          }
                        });
                      }

                    }} />
                </Col>
                <Col span="14" style={{ textAlign: "right" }}>
                  <Space>
                    <Link to="/add-sub-admin">
                      <Button
                        size="large"
                        style={{
                          borderRadius: 5,
                          padding: "6.4px 8px",
                          fontWeight: 600,
                          fontSize: 14,
                        }}
                        type="primary"
                        icon={<PlusOutlined />}
                      >
                        Add Sub Admin
                      </Button>
                    </Link>
                  </Space>
                </Col>
              </Row>
            </Space>

            <Table
              onChange={ChangeSubAdminpagination}
              columns={columns}
              pagination={{
                position: [ntop, nbottom],
                size: "small",
                defaultPageSize: 10, total: subAdminData.count, hideOnSinglePage: true
              }}
              dataSource={dataSource}
              bordered
            />
          </div>
        </div>
      </Container>
    </>
  );
}
